import { useMutation } from '@tanstack/react-query'

import { components } from '~/clients/optimus-api-types.generated'
import api from '~/clients/optimus-client'
import { handleApiRequest } from '~/hooks/tanstack-query/optimus/shared/apiWrapper'

export const useApplyRecurringAssignmentsMutation = () =>
    useMutation({
        mutationFn: (data: Omit<components['schemas']['RecurringAssignmentApplyRequest'], 'preview'>) =>
            handleApiRequest(() => api.recurringAssignments.apply({ ...data, preview: false })),
    })
